import {Avatar, IconButton, MenuItem, Stack, TextField, Tooltip, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Delete02Icon} from "@hugeicons/core-free-icons";
import {grey} from "@mui/material/colors";
import {ProjectRoles} from "../../../../context/AppContext";

export const ProjectMemberItem = ({member, setMembers}) => {

  const handleRemove = () => {
    setMembers(prev => prev?.filter(i => i?.username !== member?.username));
  }

  const handleChange = (key, value) => {
    setMembers(prev => prev?.map(i => i?.username === member?.username ? {...i, [key]: value} : {...i}));
  }

  return (
    <Stack
      direction={{xs: "column", sm: "row"}}
      alignItems={{xs: "stretch", sm: "center"}}
      gap={1.5}
      sx={{
        p: 1.5,
        borderRadius: 2.5,
        border: 1,
        borderColor: grey[200],
        transition: "border-color .15s ease",
        "&:hover": {borderColor: grey[300]}
      }}
    >
      <Stack direction={"row"} alignItems={"center"} gap={1.5} sx={{flex: 1, minWidth: 0}}>
        <Avatar sx={{
          width: 36, height: 36, fontSize: "0.85rem", fontWeight: 600,
          bgcolor: "rgba(132, 145, 247, 0.12)", color: "primary.main"
        }}>
          {member?.username?.[0]?.toUpperCase() || "?"}
        </Avatar>
        <Typography fontWeight={500} noWrap title={member?.username}>{member?.username}</Typography>
      </Stack>
      <TextField
        size={"small"}
        placeholder={"VDN (Transfer Number)"}
        value={member?.vdn || ""}
        sx={{minWidth: {xs: "100%", sm: 170}, maxWidth: {sm: 220}}}
        onChange={e => handleChange("vdn", e?.target?.value)}
      />
      <TextField
        select size={"small"}
        value={member?.role}
        sx={{minWidth: {xs: "100%", sm: 140}, maxWidth: {sm: 180}, textTransform: "capitalize"}}
        onChange={(e) => handleChange("role", e.target.value)}
      >
        {Object.entries(ProjectRoles).map(([key, value]) => (
          <MenuItem key={key} value={value} sx={{textTransform: "capitalize"}}>{value?.toLowerCase()}</MenuItem>
        ))}
      </TextField>
      <Tooltip title={"Remove Member"}>
        <IconButton onClick={handleRemove} color={"error"} size={"small"} sx={{alignSelf: {xs: "flex-end", sm: "center"}}}>
          <HugeiconsIcon icon={Delete02Icon} size={18}/>
        </IconButton>
      </Tooltip>
    </Stack>
  )
}
